/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CouponIdCodes200,
  GetApiV1CouponIdCodes401,
  GetApiV1CouponIdCodes404,
  GetApiV1CouponIdCodes500,
  GetApiV1CouponIdCodesPathParams,
  GetApiV1CouponIdCodesQueryResponse,
} from "../../types/couponCdigosController/GetApiV1CouponIdCodes.ts";
import { couponCodeGridItemViewModelSchema } from "../couponCodeGridItemViewModelSchema.ts";

export const getApiV1CouponIdCodesPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1CouponIdCodesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CouponIdCodes200Schema = z.array(
  z.lazy(() => couponCodeGridItemViewModelSchema),
) as unknown as ToZod<GetApiV1CouponIdCodes200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CouponIdCodes401Schema =
  z.any() as unknown as ToZod<GetApiV1CouponIdCodes401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CouponIdCodes404Schema =
  z.any() as unknown as ToZod<GetApiV1CouponIdCodes404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CouponIdCodes500Schema =
  z.any() as unknown as ToZod<GetApiV1CouponIdCodes500>;

export const getApiV1CouponIdCodesQueryResponseSchema = z.lazy(
  () => getApiV1CouponIdCodes200Schema,
) as unknown as ToZod<GetApiV1CouponIdCodesQueryResponse>;
